export function showWarningConsole() {
    console.log('%c¡ADVERTENCIA!', 'font-size: 24px; color: red;');
    console.log('%c\nEsta función del navegador está pensada para desarrolladores. Si alguien te indicó que copiaras y pegaras algo aquí para habilitar una función de "Mi App" o para "hackear" la cuenta de alguien, se trata de un fraude.', 'font-size: 16px; color: black;');
    Object.freeze(console);
  }
